// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/SpaceMono-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/SpaceMono-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/SpaceMono-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/SpaceMono-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Space Mono ─────────────────────────────────────────────────────────── */
@font-face {
  font-family: "Space Mono";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "Space Mono";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: "Space Mono";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 400;
  font-style: italic;
}

@font-face {
  font-family: "Space Mono";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: 700;
  font-style: italic;
}

/* ─── Reset ─────────────────────────────────────────────────────────────── */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* ─── Root container (1080×1080 Instagram square) ────────────────────────── */
.cross-root {
  position: relative;
  overflow: hidden;
  font-family: "Space Mono", monospace;
  text-align: center;
}

/* ─── Shared full-size fixed container ──────────────────────────────────── */
.cross-container {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: clip;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ─── Shared scrollable panel ───────────────────────────────────────────── */
.cross-panel {
  pointer-events: auto;
  width: 100%;
  height: 100%;
  padding-top: 150%;
  padding-bottom: 120%;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* ─── Initial transforms – must match absoluteRotations in useCrossRotation ─ */
.cross-aktuell  { transform: rotate(0deg); }
.cross-ausblick { transform: rotate(90deg) scale(-1, -1); }
.cross-info     { transform: rotate(0deg)   scale(-1, -1); }
.cross-archiv   { transform: rotate(90deg); }

/* Panels start hidden; the intro fade-in (video 1) or instant show
   (videos 2-4) sets them to opacity 1. */
.cross-aktuell,
.cross-ausblick,
.cross-info,
.cross-archiv {
  opacity: 0;
}

/* ─── Body content wrapper ──────────────────────────────────────────────── */
.cross-body {
  max-width: 520px;
  padding: 12px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  /* opacity is always 1 — blur on the parent panel controls visibility */
}

/* ─── Active vs inactive ────────────────────────────────────────────────── */
/* Inactive class is only used in interactive/preview mode, not during
   video export where anime.js controls all blur via inline styles. */
.cross-panel.inactive {
  pointer-events: none;
}

.cross-panel.inactive .cross-stepname {
  filter: blur(8px);
  opacity: 0.5;
}

.cross-panel.inactive .cross-body {
  filter: blur(8px);
  opacity: 0.5;
  pointer-events: none;
}

/* ══════════════════════════════════════════════════════════════════════════
   Panel typography — Space Mono, uniform structure across all panels
   ══════════════════════════════════════════════════════════════════════════ */

/* ─── Step name (h3) — small, uppercase, always visible ─────────────────── */
.cross-stepname {
  font-family: "Space Mono", monospace;
  font-size: 24px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: inherit;
  text-align: center;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  transition: filter 0.6s ease, opacity 0.6s ease;
  padding: 16px 32px;
}

/* ─── Main lines (h1) — large, uppercase, bold ──────────────────────────── */
.cross-line {
  font-family: "Space Mono", monospace;
  font-size: 46px;
  font-weight: 700;
  text-transform: uppercase;
  white-space: nowrap;
  line-height: 1.1;
  color: inherit;
  text-align: center;
  margin: 0;
}

/* wrappable variant — same visual style but allows line breaks (steps 3 & 4) */
.cross-line-wrap {
  font-family: "Space Mono", monospace;
  font-size: 46px;
  font-weight: 700;
  line-height: 1.15;
  color: inherit;
  text-align: center;
  margin: 0;
}

/* ─── Additional text (p) — small, normal weight ────────────────────────── */
.cross-additional {
  font-family: "Space Mono", monospace;
  font-size: 33px;
  font-weight: 400;
  color: inherit;
  text-align: center;
  margin-top: 20px;
  line-height: 1.6;
}
`, "",{"version":3,"sources":["webpack://./functions/cross-rotation/styles.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E;EACE,yBAAyB;EACzB,+DAA6D;EAC7D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+DAA0D;EAC1D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+DAA4D;EAC5D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+DAAgE;EAChE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,8EAA8E;AAC9E;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,8EAA8E;AAC9E;EACE,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,8EAA8E;AAC9E;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,gFAAgF;AAChF,kBAAkB,uBAAuB,EAAE;AAC3C,kBAAkB,sCAAsC,EAAE;AAC1D,kBAAkB,uCAAuC,EAAE;AAC3D,kBAAkB,wBAAwB,EAAE;;AAE5C;yCACyC;AACzC;;;;EAIE,UAAU;AACZ;;AAEA,8EAA8E;AAC9E;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA,8EAA8E;AAC9E;qEACqE;AACrE;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;+EAE+E;;AAE/E,8EAA8E;AAC9E;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;EACjB,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA,8EAA8E;AAC9E;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA,+EAA+E;AAC/E;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA,8EAA8E;AAC9E;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":["/* ─── Space Mono ─────────────────────────────────────────────────────────── */\n@font-face {\n  font-family: \"Space Mono\";\n  src: url(\"./assets/SpaceMono-Regular.ttf\") format(\"truetype\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Space Mono\";\n  src: url(\"./assets/SpaceMono-Bold.ttf\") format(\"truetype\");\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Space Mono\";\n  src: url(\"./assets/SpaceMono-Italic.ttf\") format(\"truetype\");\n  font-weight: 400;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Space Mono\";\n  src: url(\"./assets/SpaceMono-BoldItalic.ttf\") format(\"truetype\");\n  font-weight: 700;\n  font-style: italic;\n}\n\n/* ─── Reset ─────────────────────────────────────────────────────────────── */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n/* ─── Root container (1080×1080 Instagram square) ────────────────────────── */\n.cross-root {\n  position: relative;\n  overflow: hidden;\n  font-family: \"Space Mono\", monospace;\n  text-align: center;\n}\n\n/* ─── Shared full-size fixed container ──────────────────────────────────── */\n.cross-container {\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: clip;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* ─── Shared scrollable panel ───────────────────────────────────────────── */\n.cross-panel {\n  pointer-events: auto;\n  width: 100%;\n  height: 100%;\n  padding-top: 150%;\n  padding-bottom: 120%;\n  overflow: hidden;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* ─── Initial transforms – must match absoluteRotations in useCrossRotation ─ */\n.cross-aktuell  { transform: rotate(0deg); }\n.cross-ausblick { transform: rotate(90deg) scale(-1, -1); }\n.cross-info     { transform: rotate(0deg)   scale(-1, -1); }\n.cross-archiv   { transform: rotate(90deg); }\n\n/* Panels start hidden; the intro fade-in (video 1) or instant show\n   (videos 2-4) sets them to opacity 1. */\n.cross-aktuell,\n.cross-ausblick,\n.cross-info,\n.cross-archiv {\n  opacity: 0;\n}\n\n/* ─── Body content wrapper ──────────────────────────────────────────────── */\n.cross-body {\n  max-width: 520px;\n  padding: 12px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  /* opacity is always 1 — blur on the parent panel controls visibility */\n}\n\n/* ─── Active vs inactive ────────────────────────────────────────────────── */\n/* Inactive class is only used in interactive/preview mode, not during\n   video export where anime.js controls all blur via inline styles. */\n.cross-panel.inactive {\n  pointer-events: none;\n}\n\n.cross-panel.inactive .cross-stepname {\n  filter: blur(8px);\n  opacity: 0.5;\n}\n\n.cross-panel.inactive .cross-body {\n  filter: blur(8px);\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n/* ══════════════════════════════════════════════════════════════════════════\n   Panel typography — Space Mono, uniform structure across all panels\n   ══════════════════════════════════════════════════════════════════════════ */\n\n/* ─── Step name (h3) — small, uppercase, always visible ─────────────────── */\n.cross-stepname {\n  font-family: \"Space Mono\", monospace;\n  font-size: 24px;\n  font-weight: 400;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: inherit;\n  text-align: center;\n  user-select: none;\n  transition: filter 0.6s ease, opacity 0.6s ease;\n  padding: 16px 32px;\n}\n\n/* ─── Main lines (h1) — large, uppercase, bold ──────────────────────────── */\n.cross-line {\n  font-family: \"Space Mono\", monospace;\n  font-size: 46px;\n  font-weight: 700;\n  text-transform: uppercase;\n  white-space: nowrap;\n  line-height: 1.1;\n  color: inherit;\n  text-align: center;\n  margin: 0;\n}\n\n/* wrappable variant — same visual style but allows line breaks (steps 3 & 4) */\n.cross-line-wrap {\n  font-family: \"Space Mono\", monospace;\n  font-size: 46px;\n  font-weight: 700;\n  line-height: 1.15;\n  color: inherit;\n  text-align: center;\n  margin: 0;\n}\n\n/* ─── Additional text (p) — small, normal weight ────────────────────────── */\n.cross-additional {\n  font-family: \"Space Mono\", monospace;\n  font-size: 33px;\n  font-weight: 400;\n  color: inherit;\n  text-align: center;\n  margin-top: 20px;\n  line-height: 1.6;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
